export enum transportationUrls {
    transportation = "transportation-orders",
    relationTypes = "transportation-orders/relation-types",
    cargoTypes = "transportation-orders/cargo-types",
    statusForRelationType = "transportation-orders/statuses-for-relation-type"
}

export enum photosUrls {
    photoList = "photos/list",
    photo = "photos/photo"
}

export enum tcrUrls {
    tcr = "trailer-condition-reports"
}